import { render, staticRenderFns } from "./TfaForm.vue?vue&type=template&id=5086fedc&"
import script from "./TfaForm.vue?vue&type=script&lang=js&"
export * from "./TfaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports